<template>
  <div>
    <h1
      v-if="isDispTitle && post.title"
      class="title"
    >
      {{ post.title }}
    </h1>

    <post-body
      v-if="post.bodyHtml"
      :body="post.bodyHtml"
    ></post-body>

    <EbImages
      :images="post.images"
      :targetServiceId="post.serviceId"
    />

    <div class="block mt-5">
      <label class="has-text-weight-medium">{{ $t('term.requiredTimeToAnswer') }}</label>
      <span class="ml-4">{{ (post.requiredTime / 60) | numFormat }}</span>
      <span class="has-text-grey is-size-7 has-text-weight-light">
        ({{ $t('form.unitMinites') }})
      </span>
    </div>
  </div>
</template>
<script>
import EbImages from '@/components/molecules/EbImages'
import PostBody from '@/components/atoms/PostBody'

export default {
  name: 'PostContent',

  components: {
    EbImages,
    PostBody,
  },

  props: {
    post: {
      type: Object,
      required: true,
      default: null,
    },

    isDispTitle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    mediaServiceId() {
      return this.targetServiceId || this.serviceId
    },
  },

  watch: {},

  created() {},

  methods: {},
}
</script>
